import styled from 'styled-components';

export const AccuracyProgressWrapper = styled.div`
  display: flex;
  justify-content: center;

  width: 100%;
  height: 25px;
  margin: 3px 0;
`;

export const AccuracyWrapper = styled.div(props => {
  const borderColor = props.selected ? '#166da5' : '#9a9a9a';
  return `
    display: flex;
    justify-content: center;
    align-items: center;

    font-size: 13px;
    font-weight: ${props.selected ? 'bold' : 'normal'};
    border: 1px solid ${borderColor};
    border-radius: 15px 0 0 15px;
    width: 40%;
   
    color: ${props.selected ? '#166da5' : '#9a9a9a'};
    background-color: ${props.selected ? '#d6eaf6' : 'white'};
    border-right: ${!props.selected && 'none'};
    cursor: pointer;
    padding-top: 3px;
  `;
});

export const ProgressWrapper = styled(AccuracyWrapper)(
  props => `
  border-radius: 0 15px 15px 0;
  border-left: ${!props.selected && 'none'};
  border-right: 1px solid; 
`
);

export const IconWrapper = styled.div`
  display: flex;
  margin-left: 10px;
  padding-top: 3px;
`;

export const ToolTipInfo = styled.div`
  max-width: 150px;
  font-size: 12px;
  padding: 2px;
`;
